import { render } from "./FormBuilder.vue?vue&type=template&id=04168caf&scoped=true"
import script from "./FormBuilder.vue?vue&type=script&lang=ts"
export * from "./FormBuilder.vue?vue&type=script&lang=ts"

import "./FormBuilder.vue?vue&type=style&index=0&id=04168caf&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-04168caf"

export default script